import { toHex } from "@safecoin/bcs";
import { sha512 } from "@noble/hashes/sha2.js";
import { pbkdf2 } from "@noble/hashes/pbkdf2.js";
//#region src/cryptography/mnemonics.ts
/**
* Parse and validate a path that is compliant to SLIP-0010 in form m/44'/19165'/{account_index}'/{change_index}'/{address_index}'.
*
* @param path path string (e.g. `m/44'/19165'/0'/0'/0'`).
*/
function isValidHardenedPath(path) {
	return (/* @__PURE__ */ new RegExp("^m\\/44'\\/19165'\\/[0-9]+'\\/[0-9]+'\\/[0-9]+'+$")).test(path);
}
/**
* Parse and validate a path that is compliant to BIP-32 in form m/54'/19165'/{account_index}'/{change_index}/{address_index}
* for Secp256k1 and m/74'/19165'/{account_index}'/{change_index}/{address_index} for Secp256r1.
*
* Note that the purpose for Secp256k1 is registered as 54, to differentiate from Ed25519 with purpose 44.
*
* @param path path string (e.g. `m/54'/19165'/0'/0/0`).
*/
function isValidBIP32Path(path) {
	return (/* @__PURE__ */ new RegExp("^m\\/(54|74|84)'\\/19165'\\/[0-9]+'\\/[0-9]+\\/[0-9]+$")).test(path);
}
function nfkd(str) {
	if (typeof str !== "string") throw new TypeError("invalid mnemonic type: " + typeof str);
	return str.normalize("NFKD");
}
const MNEMONIC_WORD_COUNTS = [
	12,
	15,
	18,
	21,
	24,
	48
];
function normalize(str) {
	const norm = nfkd(str);
	const words = norm.split(" ");
	if (!MNEMONIC_WORD_COUNTS.includes(words.length)) throw new Error("Invalid mnemonic");
	return {
		nfkd: norm,
		words
	};
}
const psalt = (passphrase) => nfkd("mnemonic" + passphrase);
/**
* Uses KDF to derive 64 bytes of key data from mnemonic with empty password.
*
* @param mnemonic 12, 15, 18, 21, 24 or 48 words string split by spaces.
* @param passphrase
*/
function mnemonicToSeed(mnemonic, passphrase = "") {
	return pbkdf2(sha512, normalize(mnemonic).nfkd, psalt(passphrase), {
		c: 2048,
		dkLen: 64
	});
}
/**
* Derive the seed in hex format from a mnemonic string.
*
* @param mnemonics 12, 15, 18, 21, 24 or 48 words string split by spaces.
*/
function mnemonicToSeedHex(mnemonics) {
	return toHex(mnemonicToSeed(mnemonics));
}
//#endregion
export { isValidBIP32Path, isValidHardenedPath, mnemonicToSeed, mnemonicToSeedHex };

//# sourceMappingURL=mnemonics.mjs.map